<header>
    <app-header isWavier=true></app-header>
  </header> 
  <section class="resident-wrapper">
    <div class="outer-conatiner">
       <div class="inner-container">
         <app-page-title pageTitle='Overnight Parking Waiver Request'></app-page-title> 
         <section  class="container-wrapper ">
         <div class="text-email-div">
           <h1 style ="font-size: initial;" [ngStyle]="message=='WAIVER REQUEST APPROVED'?{'color':'green'} : {'color': 'red'}">{{message}}</h1>
           <div class="text">
           <p style="color: #9B9B9B">You have<span style="padding:5px;color:#000">{{remainingCount}}</span>waiver(s) remaining <span style="padding:5px;color:#000" >{{userSelectedYear}}</span></p>
           </div>
           <!-- <p> Please check your email and click on the link in the email. If it is not there, please check your spam mail folder.</p> -->
          <!-- <button  class="button-primary no-top-margins" (click)="goBack(message)">Exit</button> -->
          <a href="http://villageofvolo.com/parking"> <button  class="button-primary no-top-margins">Exit</button></a>
        </div>
      </section>
       <div class="" style="padding-top: 35px;">
       <h1>Waiver History {{userSelectedYear}}</h1>
        </div>
        <section class="container-wrapper parking-history">
          <div class="box" > 
        <!-- <div class="export-button" [hidden]="true">
            <button mat-button  (click)="exportAsXLSX()" color="vov-ui-primary"><i class="fa fa-upload" aria-hidden="true"></i>Export CSV</button>       
          </div> -->
            <mat-table #table [dataSource]="dataSource" matSort>
           <!-- Checkbox Column -->
  <!-- <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container> -->
  <!-- <ng-container matColumnDef="checked">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox id="selectall"  [(ngModel)]="selectedAll" (change)="onSelectAll($event,dataSource);"
      style="position: relative;bottom: 0px;">All</mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let element"> 
      <mat-checkbox  #check [checked]="element.isChecked ? true : null" name="userSelection"
      (change)="checkCheckbox(element, $event)"></mat-checkbox>
    </mat-cell>
  </ng-container> -->
          <ng-container matColumnDef="plateNo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Plate No.</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.plateNo}} </mat-cell>
          </ng-container>
          <!-- <ng-container matColumnDef="state">
            <mat-header-cell *matHeaderCellDef mat-sort-header>State</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
          </ng-container> -->
             <ng-container matColumnDef="createdAt">
               <mat-header-cell *matHeaderCellDef mat-sort-header>Wavier date </mat-header-cell>
               <mat-cell *matCellDef="let element"> {{element.startDate | date:'MM/dd/yyyy'}} </mat-cell>
             </ng-container>
             <!-- Symbol Column -->
             <ng-container matColumnDef="streetNumber">
               <mat-header-cell *matHeaderCellDef mat-sort-header> Street No.</mat-header-cell>
               <mat-cell *matCellDef="let element"> {{element.streetNumber}} </mat-cell>
             </ng-container>
             <ng-container matColumnDef="street">
               <mat-header-cell *matHeaderCellDef mat-sort-header> Street</mat-header-cell>
               <mat-cell *matCellDef="let element"> {{element.streets.street}} </mat-cell>
             </ng-container>
             <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
             <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
           </mat-table>
           <mat-paginator  #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        </section>
       </div>      
    </div>
  </section>

  <footer></footer>
